import React from 'react'
import { get } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { List } from 'shared/components'
import { displayValue } from 'shared/helpers'

export default function UsersTab({ device }) {
  const { companyId } = useParams()
  const history = useHistory()
  const users = get(device, 'license_users', [])

  const redirectToLicenseUserPage = rowData => {
    const licenseUserID = get(rowData, 'original.id')
    history.push(`/${companyId}/license_users/${licenseUserID}`)
  }

  return (
    <>
      <List
        clickable
        data={users}
        manual
        minRows={2}
        showPagination
        handleClick={rowData => redirectToLicenseUserPage(rowData)}
        columns={[
          {
            sortable: false,
            accessor: 'true_email',
            Header: __('Email'),
            Cell: rowData => displayValue(rowData.value),
            minWidth: 250,
            width: 350
          },
          {
            sortable: false,
            accessor: 'first_name',
            Header: __('First Name'),
            Cell: rowData => displayValue(rowData.value),
            maxWidth: 250
          },
          {
            sortable: false,
            accessor: 'last_name',
            Header: __('Last Name'),
            Cell: rowData => displayValue(rowData.value),
            maxWidth: 250
          },
          {
            sortable: false,
            accessor: 'phone_number',
            Header: __('Phone Number'),
            Cell: rowData => displayValue(rowData.value),
            maxWidth: 250
          }
        ]}
      />
    </>
  )
}
